<template>
<div class="container-box">
    <div :id="id" :style="{height:height,width:width}"></div>
</div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: ['className', 'id', 'height', 'width', 'type', 'echartsData'],
    data() {
        return {}
    },
    mounted() {
        let data = [],
            xAxisData = [];
        this.echartsData.map(item => {
            data.push(item.num);
            xAxisData.push({
                value: item.name,
                textStyle: {
                    color: '#04C3F1'
                }
            });
        })
        this.initData(data.reverse(), xAxisData.reverse());
    },
    beforeDestroy() {

    },
    methods: {

        initData(data, xAxisData) {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById(this.id))
            // 绘制图表
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '5%',
                    top: '5%',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    show: false,
                    boundaryGap: [0, 0.01]
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    data: xAxisData
                },
                series: [{
                    name: '',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#04C3F1'
                    },
                    barWidth: '50%',
                    data: data
                }],
                color: {
                    type: 'linear',
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    colorStops: [{
                        offset: 0,
                        color: 'transparent' // 0% 处的颜色
                    }, {
                        offset: 1,
                        color: '#04C3F1' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            })
        },

    }
}
</script>

<style lang="less" scoped>
</style>
